"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const Urls_1 = require("../Urls");
/* eslint-disable no-useless-catch */
class MessageAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    syncMessages(from, params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const urlPath = this.config.baseUrl +
                    Urls_1.urls.syncChat(from) +
                    this.syncMessagesQueryString(params);
                const messages = yield this.httpAdapter.get(urlPath, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(messages.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getMessages(from, params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const urlPath = this.config.baseUrl +
                    Urls_1.urls.chat(from) +
                    this.getMessagesQueryString(params);
                const messages = yield this.httpAdapter.get(urlPath, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(messages.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getMessagesQueryString(params) {
        let queryString = `?limit=${params.limit}&chatType=${params.chatType}&total=${params.total}`;
        if (params.filterBySenderIds) {
            queryString += `&filterBySenderIds=${params.filterBySenderIds}`;
        }
        if (params.search) {
            queryString += `&search=${encodeURIComponent(params.search)}`;
        }
        return queryString;
    }
    syncMessagesQueryString(params) {
        return `?limit=${params.limit}&chatType=${params.chatType}&total=${params.total}&lastSyncedAt=${params.lastSyncedAt}`;
    }
    fetchRecipientInfo(messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.ackRecipientList(messageId));
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    setMessageStar(starMessageRequestData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.starMessage, starMessageRequestData);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
}
exports.MessageAdapter = MessageAdapter;
